import type { FunctionComponent } from 'react';
import { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { useAuth } from 'react-oidc-context';


import { Button, ButtonSize } from '../../../shared/components/button/button';
import { useDesktop } from '../../../shared/hooks/breakpoint';
import { useFullPath } from '../../../shared/hooks/use-full-location';
import { useSignIn } from '../../../shared/hooks/use-sign-in';
import { createStyleHelper } from '../../../shared/utils/class-names';
import { useLayoutContext } from '../../util/layout-context';

import styles from './account-actions.module.scss';

const style = createStyleHelper(styles, 'account-actions');

export const AccountActions: FunctionComponent = memo(() => {
    const auth = useAuth();
    const isFullDisplay = useDesktop();
    const { layout } = useLayoutContext();
    const signIn = useSignIn();
    const returnPath = useFullPath();


    return (
        <div className={style()}>
            {!isFullDisplay && !auth.isAuthenticated && !!layout.showNavButtons ? (
                <div className={style('actions')}>
                    <Button className={style('cta')} size={ButtonSize.SMALL} href="/">
                        <FormattedMessage id="main-layout.cta.home" defaultMessage="HOME" />
                    </Button>
                </div>
            ) : (
                <div className={style('actions')}>
                    <Button className={style('cta')} size={ButtonSize.SMALL} href="/">
                        <FormattedMessage id="main-layout.cta.home" defaultMessage="HOME" />
                    </Button>
                    <Button
                        className={style('cta')}
                        hollow
                        light
                        size={ButtonSize.SMALL}
                        onClick={signIn}
                    >
                        <FormattedMessage id="account-actions.cta.login" defaultMessage="Login" />
                    </Button>
                </div>
            )}
            {!isFullDisplay && auth.isAuthenticated ? (
                <div className={style('actions')}>
                    <Button
                        className={style('cta')}
                        hollow
                        light
                        size={ButtonSize.SMALL}
                        href={`/logout?backTo=${returnPath}`}
                    >
                        <FormattedMessage id="account-actions.cta.logout" defaultMessage="Logout" />
                    </Button>
                </div>
            ) : null}
        </div>
    );
});
